import React, { FC, useState,KeyboardEvent, useEffect} from 'react'
import Frame from 'components/Frame'
import styled from 'styled-components'
import { useHistory, withRouter } from "react-router-dom";
import BG from 'assets/img/BG.png'
import fonts from 'const/style/fonts';
import StepImage1 from 'assets/img/home/ic_cloud_info_24px.svg'
import StepImage2 from 'assets/img/home/Component14–2.svg'
import StepImage3 from 'assets/img/home/Component13–2.svg'
import LeftWhiteButton from 'assets/icon/ic_chevron_left_white_24px.svg'
import LeftBlackButton from 'assets/icon/ic_chevron_left_black_24px.svg'
import RightWhiteButton from 'assets/icon/ic_chevron_right_white_24px.svg'
import RightBlackButton from 'assets/icon/ic_chevron_right_black_24px.svg'
import colors from 'const/style/colors';
import Modal from 'components/Modal';
import Spinner from 'components/Spinner';
import Login from 'models/Login';
import { inject, observer } from 'mobx-react';

import IconJobFlex from 'assets/icon/ic_jobflex_white.png'
import Footer from 'components/Footer';
import ApplicantInfoView from 'components/ApplicantInfoView';
import { async } from 'q';
import UserStatusType from 'consts/UserStatusType';
import config from 'config';
import { initializeInstance } from 'mobx/lib/internal';
import PtCountErrorModal from 'components/PtCountErrorModal';


const ApplicantHomeFrame = styled(Frame)`
    background-image: url(${BG});
    background-size:100% 100%;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:unset;
   
  

    .main-frame{
    display:flex;
    flex-direction:row;
    justify-content:space-around;
    align-items:center;
 
        button{
            width:45px;
            height:45px;
            background: #FFFFFF4D 0% 0% no-repeat padding-box;
            border: 1px solid #FFFFFF;
            border-radius: 3px;
            opacity: 1;
            :active{
                border: 1px solid #FFFFFF;
                border-radius: 3px;
                opacity: 1;
            }
        }

        .left{
            margin-left:auto;
            margin-right:5em;
            background: url(${LeftWhiteButton}) no-repeat 50% 50%;
            :active{
                background: #FFFFFF url(${LeftBlackButton}) no-repeat 50% 50%;
            }
            :disabled {
                visibility:hidden;
            }
        }
        .right{
            margin-right:auto;
            margin-left:5em;
            background: url(${RightWhiteButton}) no-repeat 50% 50%;
            :active{
                background: #FFFFFF url(${RightBlackButton}) no-repeat 50% 50%;
            }
            :disabled {
                visibility:hidden;
            }
        }
    

    }

   h1{
    ${fonts.H1_White};} 
   }
   h2{
    ${fonts.H2_White};} 
   }

   .next-btn{
    background: #2E303C 0% 0% no-repeat padding-box;
    border-radius: 5px;
    opacity: 1;
    width: 200px;
    height: 40px;
    font-size:18px;
    color:white;
    margin-top:4vmin;

    :disabled {
        visibility:hidden;
    }
   }
 

   .frame-footer {
     position:fixed;
     bottom:0;
  }
`


const ApplicantInfo = styled.div`
pointer-events:none;
width: 646px;
height: 353px;
background: #FFFFFF1A 0% 0% no-repeat padding-box;
border: 1px solid #FFFFFF;
border-radius: 2px;
opacity: 1;
display:inline-flex;
flex-direction:column;
align-items:center;
-webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
h2{
    margin-top:50px;
}
img{
    margin-top:60px;
}
`

const SlideFrame = styled.div`
margin-top:2em;
margin-bottom:1em;
width:646px;
  /* flex:1; */
  &:focus {
    outline:none;
  }
  
  display:flex;
  flex-direction:row;
  flex-wrap:nowrap;
  justify-content:flex-start;
  align-items:center;
 
  .frame {
    position:relative;
    width: 646px;
    height:100%;
    overflow-x:hidden;
    .container {
      width:auto;
      height:auto;
      white-space:nowrap;
      flex-direction:row;
      transition:transform ease .5s;
      transform: ${(props) => `translate(${(props as any)['data-slide'] * -646}px, 0)`};
 
    }
  }
`;


interface IApplicantHomeProp {
    loginInfo?: Login;
}

const ApplicantHome: FC<IApplicantHomeProp> = (props: IApplicantHomeProp) => {
    const { loginInfo }: IApplicantHomeProp = props;
    const history = useHistory();
    const [isNextCheck, setIsNextCheck] = useState<boolean>(false);

    const [slideIdx, setSlideIdx] = useState<number>(0);

    const nextClick = async (data: any) => {
        if (isNextCheck)   {
            await loginInfo?.updateNow();
            if(!loginInfo?.ptCountCheck)
                return;
            history.push("/upload");
        } else
            setIsNextCheck(true);
    };


    const leftClick = (data: any) => {
        if (slideIdx >= 1) setSlideIdx(slideIdx - 1)
    };
    const rightClick = (data: any) => {
        if (slideIdx < 2) setSlideIdx(slideIdx + 1)
    };

    useEffect(() => {

        if(!loginInfo?.userInfo ?.name)return;
        if(loginInfo.userInfo?.userStatusType === UserStatusType.PDF_UPLOAD)return;
        const init = async() => {
            await loginInfo!.getTTS(`${loginInfo?.userInfo ?.name} 님 반갑습니다. 지금부터 온라인 PT를 진행합니다. 온라인 PT전형의 진행 절차는 아래와 같습니다.`);
            let audio = new Audio(`${loginInfo?.URL_TTS}${loginInfo!.audio}`);
            audio.play();
        }
        init();
    }, [loginInfo?.userInfo?.name])
    
    if (!loginInfo)throw new Error('no loginInfo Found');

    

    useEffect(()=>{
        const init=async()=>{
          await loginInfo!.loginCheck();
          if(loginInfo.userInfo?.userStatusType === UserStatusType.PDF_UPLOAD) {
              history.replace('/continuePT');
          }
        }
        init();
    }, [])


    return (
        <ApplicantHomeFrame>
            <img className='jobflex-logo' src={IconJobFlex}></img>
            <ApplicantInfoView></ApplicantInfoView>

            <h1>{loginInfo.userInfo ?.name} 님 반갑습니다.</h1>
            <h2>지금부터 온라인 PT전형을 진행합니다. 온라인 PT전형의 진행 절차는 아래와 같습니다.</h2>

            <div className='main-frame'>

                <button className='left' onClick={leftClick} disabled={slideIdx === 0} />
                <SlideFrame
                    data-slide={slideIdx}
                    tabIndex={0}
                    onKeyUp={(e: KeyboardEvent<HTMLElement>) => {
                        switch (e.key) {
                            case 'ArrowLeft':
                                leftClick(null);
                                break;
                            case 'ArrowRight':
                                rightClick(null);
                                break;
                        }
                    }}>
                    <div className='frame'>
                        <div className='container'>
                            <ApplicantInfo>
                                <h2>1. 프레젠테이션에서 사용할 자료를 업로드합니다.</h2>
                                <img src={StepImage1}></img>
                            </ApplicantInfo>
                            <ApplicantInfo>
                                <h2>2. 발표자료가 잘 업로드되었는지 2분동안 확인합니다.</h2>
                                <img src={StepImage2}></img>
                            </ApplicantInfo>
                            <ApplicantInfo>
                                <h2>3. 발표 자료의 슬라이드 순서에 맞춰 프레젠테이션을 진행합니다.</h2>
                                <img src={StepImage3}></img>
                            </ApplicantInfo>
                        </div>
                    </div>
                </SlideFrame>
                <button className='right'
                    onClick={rightClick} disabled={slideIdx === 2}
                > </button>
            </div>
            <div>

                <button className='next-btn' onClick={nextClick} disabled={slideIdx !== 2}>다음 화면으로 이동</button>

            </div>
            <Modal open={isNextCheck}>
                <h2 className='black'>발표자료 업로드 페이지로 이동합니다.</h2>
                <button className="btn-cta2" onClick={nextClick}>다음 화면으로 이동</button>
                <button className="btn-cta" onClick={() => setIsNextCheck(false)}>진행절차 다시 확인</button>
            </Modal>
            <Footer />
        </ApplicantHomeFrame>
    )

}

export default withRouter((inject('loginInfo')(observer(ApplicantHome))) as any);